import { airconDeals } from './airconDeals'

/**
 * OfferCatalog for the aircon hub and locality pages' JSON-LD.
 *
 * Built from the same arrays the pages render (airconCostCalculation's
 * standardServicing / chemicalServicing / overhaulServicing, and airconDeals
 * for gas and compressor work), so a price change reaches the markup and the
 * visible tables together. Both pages used to hard-code these figures in
 * their JSON-LD strings, where a price change would silently leave the schema
 * claiming the old price.
 */
const offer = (name, service, price) => ({
    '@type': 'Offer',
    name,
    priceCurrency: 'SGD',
    price: Number(price).toFixed(2),
    itemOffered: { '@type': 'Service', name: service },
})

const dealCost = (serviceType, unit = 1) =>
    airconDeals.find((d) => d.serviceType === serviceType && d.unit === unit)?.cost ?? null

const rate = (rows, units) => {
    const value = Number(rows?.[units - 1]?.rate)
    return Number.isFinite(value) && value > 0 ? value : null
}

export const buildAirconOfferCatalog = ({
    name,
    standardServicing,
    chemicalServicing,
    overhaulServicing,
    includeCompressor = false,
}) => {
    const offers = [
        [`General Aircon Servicing - 1 unit`, 'General Aircon Servicing', rate(standardServicing, 1)],
        [`General Aircon Servicing - 2 units`, 'General Aircon Servicing', rate(standardServicing, 2)],
        [`General Aircon Servicing - 5 units`, 'General Aircon Servicing', rate(standardServicing, 5)],
        [`Aircon Chemical Wash - 1 unit`, 'Aircon Chemical Wash', rate(chemicalServicing, 1)],
        [`Aircon Chemical Overhaul - 1 unit`, 'Aircon Chemical Overhaul', rate(overhaulServicing, 1)],
        includeCompressor && [`Compressor Cleaning - 1 compressor`, 'Aircon Compressor Cleaning', dealCost('compressorCleaning')],
        includeCompressor && [`Compressor Chemical Wash - 1 compressor`, 'Aircon Compressor Chemical Wash', dealCost('compressorChemicalCleaning')],
        [`Refrigerant Gas Top Up - 1 unit full tank`, 'Aircon Gas Top Up', dealCost('gasRefill')],
    ]
        .filter((row) => row && row[2])
        .map(([offerName, service, price]) => offer(offerName, service, price))

    return { '@type': 'OfferCatalog', name, itemListElement: offers }
}
